import { Box, Button, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import { Fragment, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import {
  GenericTableColumTypes,
  GenericTableFilterTypes,
} from "../../enum/TableView";
import { MenuItem } from "primereact/menuitem";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { removeIndustry } from "../../service/industryService";
import { RouteComponentProps } from "../../models/RouteComponent";
import { rolesRemove, rolesUpdate } from "../../service/rolesService";
import { useNavigate } from "react-router-dom";
import DocumentsAdd from "./documents-Add";
import { removeDocument, updateDocument } from "../../service/documentsService";
import { TabPanel, TabView } from "primereact/tabview";
import ClientDocumentsView from "./client-documents/client-documents-View";
import EquipmentDocumentsView from "./equipment-documents/equipment-documents-View";
import ConsultantDocumentsView from "./consultant-documents/consultant-documents-View";
import SubcontractorDocumentsView from "./subcontractor-documents/subcontractor-documents-View";
import EmployeeDocumentsView from "./employee-documents/employee-documents-View";
import VehicleDocumentsView from "./vehicle-documents/vehicle-documents-View";
import ChemicalDocumentsView from "./chemical-documents/chemical-documents-View";
import SiteDocumentsView from "./site-documents/site-documents-View";
import InfoIcon from "@mui/icons-material/Info";

export default function DocumentsView(props: RouteComponentProps) {
  const toast = useRef(null as any);

  const client_id = props?.session?.client_id;
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Fragment>
      {
        client_id && (
          <Box
            sx={{
              mb: 3,
              p: 2.5,
              backgroundColor: "#e3f2fd",
              borderRadius: "md",
              border: "2px solid #2196f3",
              display: "flex",
              alignItems: "flex-start",
              gap: 1.5,
              boxShadow: "0 2px 8px rgba(33, 150, 243, 0.15)",
            }}
          >
            <InfoIcon
              sx={{
                color: "#1976d2",
                fontSize: "1.25rem",
                mt: 0.25,
                flexShrink: 0
              }}
            />
            <Box>
              <Typography
                level="body-md"
                sx={{
                  mb: 0.5,
                  fontWeight: "lg",
                  color: "#1565c0",
                  lineHeight: 1.4
                }}
              >
                Use this page to add extra document types your company needs.
              </Typography>
              <Typography
                level="body-sm"
                sx={{
                  color: "#1976d2",
                  lineHeight: 1.5
                }}
              >
                First select the relevant tab – Company, Employees, Subcontractors, Equipment, Vehicles & Plant, Chemicals, or Site/Project – then add the document name, description, and choose if it’s Required.

                Note: This page is only for setting up document types. The actual files are uploaded later on the relevant records (e.g. employee profile, equipment item, or site safety file)..
              </Typography>
            </Box>
          </Box>)
      }
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Company">
          <ClientDocumentsView
            setGlobalLoader={props.setGlobalLoader}
            toast={toast}
            client_id={client_id}
          />
        </TabPanel>

        <TabPanel header="Employees">
          <EmployeeDocumentsView
            setGlobalLoader={props.setGlobalLoader}
            toast={toast}
            client_id={client_id}
          />
        </TabPanel>
        <TabPanel header="Subcontractors">
          <SubcontractorDocumentsView
            setGlobalLoader={props.setGlobalLoader}
            toast={toast}
            client_id={client_id}
          />
        </TabPanel>
        {
          !client_id && (
            <TabPanel header="DSF Consultant">
              <ConsultantDocumentsView
                setGlobalLoader={props.setGlobalLoader}
                toast={toast}
                client_id={client_id}
              />
            </TabPanel>
          )
        }
        <TabPanel header="Equipment">
          <EquipmentDocumentsView
            setGlobalLoader={props.setGlobalLoader}
            toast={toast}
            client_id={client_id}
          />
        </TabPanel>
        <TabPanel header="Vehicles & Plant">
          <VehicleDocumentsView
            setGlobalLoader={props.setGlobalLoader}
            toast={toast}
            client_id={client_id}
          />
        </TabPanel>
        <TabPanel header="Chemicals">
          <ChemicalDocumentsView
            setGlobalLoader={props.setGlobalLoader}
            toast={toast}
            client_id={client_id}
          />
        </TabPanel>
        <TabPanel header="Site/Project">
          <SiteDocumentsView
            setGlobalLoader={props.setGlobalLoader}
            toast={toast}
            client_id={client_id}
          />
        </TabPanel>
      </TabView>
      <Toast ref={toast} />
    </Fragment>
  );
}
